// Set up your application entry point here...

import 'babel-polyfill';
import React from 'react';
import {render} from 'react-dom';
import {Router, browserHistory, Route} from 'react-router';
import routes from './routes';
import {Provider} from 'react-redux';
import configureStore from './store/configureStore';

require('./favicon.ico'); // Tell webpack to load favicon.ico
import './styles/sas/styles.scss'; // Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.
import {addLocaleData} from 'react-intl';
import {IntlProvider} from 'react-intl-redux';
import nl from 'react-intl/locale-data/nl';
import fr from 'react-intl/locale-data/fr';
import de from 'react-intl/locale-data/de';
import ReactGA from 'react-ga';
import initialState from './store/initialState';
import {routerStateChange} from './modules/routing/actions';
import {basePath} from './constants/public-routes';
import Headpart from "./modules/app/components/Headpart";

ReactGA.initialize('UA-87734787-1');

function logPageView() {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.set({page: window.location.pathname});
    ReactGA.pageview(window.location.pathname);
  }
}

addLocaleData([
  ...nl,
  ...fr,
  ...de
]);

const state = window.__PRELOADED_STATE__ ? window.__PRELOADED_STATE__ : initialState();

const store = configureStore(state);

// export const headerRoutes = (
//
//     <Route component={Headpart}/>
//
//   );
//
// render(
//   <Router routes={headerRoutes}/>
//   ,   document.getElementById("navbar")
// );


render(
  <Provider store={store}>
    <IntlProvider>
      <Router routes={routes} history={browserHistory} onUpdate={function () {
        let self = this;
        const {hash} = window.location;
        if (hash !== '') {
          // Push onto callback queue so it runs after the DOM is updated,
          // this is required when navigating from a different page so that
          // the element is rendered on the page before trying to getElementById.
          setTimeout(() => {
            const id = hash.replace('#', '');
            const element = document.getElementById(id);
            if (element) element.scrollIntoView();
          }, 0);
        }
        else {
          if (!window.location.search.match(/page=/)) {
            window.scrollTo(0, 0);
          }
          logPageView();
          store.dispatch(routerStateChange(self.state));
        }
      }}/>
    </IntlProvider>
  </Provider>,
  document.getElementById('app')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/